module.exports = __webpack_public_path__ + "fonts/Manrope-400-latin-ext5.4e3c84a.woff2";